var ko = require('knockout');
require('knockout-postbox');

var PAGE_TYPE = {
  PERSONAL_INFO: 'registration-personal-info',
  PERSONAL_STATUS: 'registration-info-member',
  EMPLOYER: 'registration-employer',
  ENROLL: 'registration-enroll',
  AGENCY: 'registration-agency',
  INSURANCE: 'registration-insurance',
  CONFIRMATION: 'registration-confirmation',
  END: 'registration-end'
};

var PAGE_NAMES = {};
PAGE_NAMES[PAGE_TYPE.PERSONAL_INFO] =
  window.language.registrationPage.personalInfo;
PAGE_NAMES[PAGE_TYPE.PERSONAL_STATUS] =
  window.language.registrationPage.personalStatus;
PAGE_NAMES[PAGE_TYPE.EMPLOYER] = window.language.registrationPage.employer;
PAGE_NAMES[PAGE_TYPE.ENROLL] = window.language.registrationPage.applicant;
PAGE_NAMES[PAGE_TYPE.AGENCY] = window.language.registrationPage.agency;
PAGE_NAMES[PAGE_TYPE.INSURANCE] = window.language.registrationPage.insurance;
PAGE_NAMES[PAGE_TYPE.CONFIRMATION] =
  window.language.registrationPage.confirmation;
PAGE_NAMES[PAGE_TYPE.END] = window.language.registrationPage.end;

var SIGNUP_TYPE = {
  agency: 'Byråmedlemskap',
  person: 'Personmedlemskap'
};

function RegistrationPages(params) {
  var self = this;

  self.$body = $('html, body');
  self.STEP = { PERSONAL: 0, EMPLOYER: 1, AUTHORIZATION: 2, CONFIRMATION: 3 };

  self.API = params.api;
  self.links = params.links;
  self.signuptype = params.signuptype;
  self.text = params.text;
  self.errorMessages = params.errorMessages;

  self.steps = null;
  self.headerSteps = ko.observableArray([]);
  self.currentsignuptype = SIGNUP_TYPE[self.signuptype];

  self.stepHistory = ko.observableArray([]);

  if (
    self.signuptype === 'person' ||
    self.signuptype === 'studentandpractice'
  ) {
    self.steps = ko.observableArray([
      PAGE_TYPE.PERSONAL_INFO,
      PAGE_TYPE.PERSONAL_STATUS,
      PAGE_TYPE.EMPLOYER,
      PAGE_TYPE.CONFIRMATION,
      PAGE_TYPE.END
    ]);
  } else if (self.signuptype === 'studentandpractice') {
    self.steps = ko.observableArray([
      PAGE_TYPE.PERSONAL_INFO,
      PAGE_TYPE.PERSONAL_STATUS,
      PAGE_TYPE.CONFIRMATION,
      PAGE_TYPE.END
    ]);
  } else if (self.signuptype === 'agency') {
    self.steps = ko.observableArray([
      PAGE_TYPE.ENROLL,
      PAGE_TYPE.AGENCY,
      PAGE_TYPE.INSURANCE,
      PAGE_TYPE.CONFIRMATION,
      PAGE_TYPE.END
    ]);
  } else {
    throw "signuptype must be 'person' or 'agency'.";
  }

  var regData = sessionStorage.getItem('rn-registration');

  if (regData !== undefined && regData !== null) {
    var parsedRegData = JSON.parse(regData);
    if (parsedRegData.steps !== undefined) {
      this.steps(parsedRegData.steps);
    }
    if (parsedRegData.headerSteps !== undefined) {
      this.headerSteps(parsedRegData.headerSteps);
    }
  } else {
    this.setHeaderSteps();
  }

  self.steps.subscribe(function() {
    self.setHeaderSteps();
  });

  self.currentStep = ko.observable(0);
  self.mainContainer = $('.form-steps-container');
  self.containers = $('.container-white');
  self.maxHeight = ko.observable(0);

  // Initialize the step.
  if (window.location.hash.indexOf('#step=') === -1) {
    window.location.hash = '#step=' + self.currentStep();
  } else {
    self.setHash();
  }

  self.currentStep.subscribe(function() {
    window.location.hash = '#step=' + self.currentStep();
  });

  window.onhashchange = function() {
    self.setHash();
  };

  this.trackStep('nextStep');
}

RegistrationPages.prototype.setHeaderSteps = function() {
  var length = this.steps().length,
    tmpArr = [];
  // We do not want to include PAGE_TYPE.END in the headersteps.
  // Currently all signuptypes have a PAGE_TYPE.END which means we
  // can just set the length-1.
  for (var i = 0; i < length - 1; i++) {
    tmpArr.push(PAGE_NAMES[this.steps()[i]]);
  }
  this.headerSteps(tmpArr);
  this.storeValues();
};

RegistrationPages.prototype.storeValues = function() {
  this.storeValuesForStep('steps', this.steps());
  this.storeValuesForStep('headerSteps', this.headerSteps());
};

RegistrationPages.prototype.storeValuesForStep = function(stepType, data) {
  // 1: Get the registration data.
  var regData = sessionStorage.getItem('rn-registration');

  // 2: If the data does not exist, create an empty object.
  //    If it does exist, parse the information.
  if (regData === undefined || regData === null) {
    regData = {};
  } else {
    regData = JSON.parse(regData);
  }

  // 3: Update the stepType with the data to store.
  regData[stepType] = data;

  // 4: Update the lastUpdated date.
  regData.lastUpdated = new Date().getTime();

  // 5: Store the object in session storage.
  sessionStorage.setItem('rn-registration', JSON.stringify(regData));
};

RegistrationPages.prototype.saveStep = function() {
  // 1: Get the registration data.
  var regData = sessionStorage.getItem('rn-registration');

  // 2: If the data does not exist, create an empty object.
  //    If it does exist, parse the information.
  if (regData === undefined || regData === null) {
    regData = {};
  } else {
    regData = JSON.parse(regData);
  }

  // 3: Update the stepType with the data to store.
  regData.currentStep = this.currentStep();

  // 4: Update the lastUpdated date.
  regData.lastUpdated = new Date().getTime();

  // 5: Store the object in session storage.
  sessionStorage.setItem('rn-registration', JSON.stringify(regData));
};

RegistrationPages.prototype.triggerModal = function() {
  this.activeModal(!this.activeModal());
};

RegistrationPages.prototype.closeModal = function() {
  this.activeModal(false);
};

RegistrationPages.prototype.calculateHeight = function() {
  // var newHeight = $(this.containers[this.currentStep()]).outerHeight();
  var newHeight = $('.container-white').outerHeight();
  // if (newHeight > parseInt(this.maxHeight(), 10)) {
  this.maxHeight(newHeight + 'px');
  // }
};

RegistrationPages.prototype.setHash = function() {
  if (window.location.hash.indexOf('#step=') !== -1) {
    var step = parseInt(window.location.hash.substring('#step='.length), 10);
    var oldStep = this.currentStep();
    this.currentStep(step);
    // Only scroll to the top if we're moving forwards.
    if (step >= oldStep) {
      this.$body.animate({ scrollTop: 0 }, 200);
    }
  }
};

RegistrationPages.prototype.addInputControlForPage = function(inputFields) {
  inputFields.on('keydown', function(e) {
    // If it is submit/enter on normal text fields or submit on (input type number fields)/tab.
    var keyCode = e.keyCode || e.which;
    if (keyCode === 13 || keyCode === 9) {
      inputFields.eq(inputFields.index(this)).blur();

      if (inputFields.index(this) + 1 <= inputFields.length - 1) {
        // I have to have a timeout here or else the input field will be focused before it can properly
        // blur. Which means that on e.g. Android you will have the previous input prepended to the new
        // input field.
        window.setTimeout(
          function() {
            // If the user holds in shift (tab backwards).
            var tmpNewField = null;
            if (e.shiftKey) {
              tmpNewField = inputFields.eq(inputFields.index(this) - 1);
            } else {
              tmpNewField = inputFields.eq(inputFields.index(this) + 1);
            }
            tmpNewField.focus();
            if (tmpNewField.hasClass('selectized')) {
              // Not the ideal solution, but I need to be able to trigger the selectize input.
              // The selectize plugin has a div to simulate the dropdown and it is this div I attempt to click.
              tmpNewField
                .siblings('.selectize-control')
                .find('.selectize-input')
                .click();
            }
          }.bind(this),
          10
        );
        e.preventDefault();
      }
    }
  });
};

RegistrationPages.prototype.removeInputControlForPage = function(inputFields) {
  if (inputFields !== null) {
    inputFields.off('keydown');
  }
};

RegistrationPages.prototype.addSteps = function(index, steps) {
  for (var i = steps.length - 1; i >= 0; i--) {
    this.steps.splice(index, 0, steps[i]);
  }
  this.setHeaderSteps();
};

RegistrationPages.prototype.validateFields = function(fields) {
  var isValid = true;

  for (var i = 0; i < fields.length; i++) {
    if (fields[i]() === undefined || fields[i]() === null) {
      fields[i].hasError(true);
    }
    if (fields[i].hasError()) {
      isValid = false;
    }
  }

  return isValid;
};

/**
 * @param String type: Is either "nextStep" or "previousStep".
 */
RegistrationPages.prototype.trackStep = function(type) {
  window.dataLayer.push({
    signupType: this.signuptype,
    stepType: this.headerSteps()[this.currentStep()],
    event: type
  });
};

RegistrationPages.prototype.trackRegistrationSent = function() {
  window.dataLayer.push({
    signupType: this.signuptype,
    stepType: PAGE_NAMES[PAGE_TYPE.END],
    event: 'sendRegistrationButtonClicked'
  });
};

RegistrationPages.prototype.previousStep = function() {
  this.currentStep(this.currentStep() - 1);

  // If we're back to the first step in agency signuptype, we need to revert back
  // the steps and headersteps because they may change depending on the choice of the user.
  if (this.currentStep() === 0 && this.signuptype === 'agency') {
    this.steps([
      PAGE_TYPE.ENROLL,
      PAGE_TYPE.AGENCY,
      PAGE_TYPE.INSURANCE,
      PAGE_TYPE.CONFIRMATION,
      PAGE_TYPE.END
    ]);
    this.setHeaderSteps();
  }
  this.trackStep('previousStep');
};

RegistrationPages.prototype.nextStep = function(skip) {
  if (skip) {
    this.currentStep(this.currentStep() + 1 + skip);
  } else {
    this.currentStep(this.currentStep() + 1);
    if (this.currentStep() < this.headerSteps().length) {
      this.trackStep('nextStep');
    } else if (this.currentStep() == this.headerSteps().length) {
      this.trackRegistrationSent();
    }
  }
};

RegistrationPages.prototype.nextStepSkip = function() {
  this.currentStep(this.currentStep() + 1);
};

module.exports = RegistrationPages;
